import React, {useState} from 'react';
import ImageSrc from "../../assets/images/google.svg";
import {Link, useNavigate} from 'react-router-dom';
import axios from "axios";
import {setToken, setUser} from "../../Redux/Actions/userActions";
import {useDispatch, useSelector} from "react-redux";
import {Spinner} from "react-bootstrap";
import apiClient from "../../utils/api";
import {toast} from "react-toastify";

function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const response = await apiClient.post('/auth/signin', {
                email,
                password
            });

            if (response.status === 200 && response.data) {
                console.log(response.data)
                dispatch(setToken(response.data.token));
                dispatch(setUser(response.data.user));
                localStorage.setItem('auth_token', response.data.token);
                //toast.success(response.data.message);
                navigate('/accounts/dashboard');
            } else {
                //  set error message validations errors etc
            }
        } catch (error) {
            if (error.response && error.response.data.message) {
                toast.error(error.response.data.message);
            }
            /*if (error.response) {
                toast.success('Registration failed!');
            } else {
                toast.success(`Error: ${error.message}`);
            }*/
        } finally {
            setLoading(false)
        }
    };


    return (
        <div
            className="container-fluid d-flex justify-content-center align-items-center border-0 rounded-lg auth-h100">
            <div className="row">
                <div className="col-md-6 col-lg-6 w-100  p-3 p-md-5 card border-0 shadow-sm">
                    <form className="row g-1 p-3 p-md-4 mt-5" onSubmit={handleSubmit}>
                        <div className="col-12 text-center mb-0">
                            <h1>Sign in</h1>
                            {/* <span>Free access to our dashboard.</span> */}
                        </div>
                        <div className="col-12 text-center mb-4">
                            {/*<Link className="btn btn-lg btn-light btn-block" to="#!">
                            <span className="d-flex justify-content-center align-items-center">
                                <img className="avatar xs me-2" src={ImageSrc} alt="img Description" />
                                Sign in with Google
                            </span>
                        </Link>
                        <span className="dividers text-muted mt-4">OR</span>*/}
                        </div>
                        <div className="col-12">
                            <div className="mb-2">
                                <label className="form-label">Email address</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    className="form-control form-control-lg lift"
                                    placeholder="name@example.com"
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="mb-2">
                                {/* <div className="form-label">
                                <span className="d-flex justify-content-between align-items-center">
                                    Password
                                    <Link className="text-secondary" to={process.env.PUBLIC_URL + "/reset-password"}>Forgot Password?</Link>
                                </span>
                            </div>*/}
                                <input
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                    className="form-control form-control-lg lift"
                                    placeholder="***************"
                                />
                            </div>
                        </div>
                        {/* <div className="col-12">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Remember me
                            </label>
                        </div>
                    </div>*/}
                        <div className="col-12 text-center mt-4">
                            <button
                                style={{minWidth:'130px'}}
                                type='submit'
                                className="btn btn-lg btn-block btn-light lift text-uppercase">
                                {loading ? (
                                    <>
                                        <Spinner as="span" animation="border" size="sm" role="status"
                                                 aria-hidden="true"/> Loading...
                                    </>
                                ) : (
                                    'SIGN IN'
                                )}
                            </button>
                        </div>
                        {/* <div className="col-12 text-center mt-4">
                        <span>Don't have an account yet? <Link to={process.env.PUBLIC_URL + "/sign-up"} className="text-secondary">Sign up here</Link></span>
                    </div>*/}
                    </form>
                </div>
            </div>
        </div>

    );
}


export default SignIn;